import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * La page pleine est remplacée par le volet dossier de `/claims` : un lien partagé, un favori
 * ou un retour d'historique atterrit sur le même écran que le reste de l'application.
 * `OverviewTab` reste utilisé — c'est le volet qui le monte.
 */
export const Route = createFileRoute("/_authed/_dashboard/claims/$claimId/overview")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/claims",
      search: { claimId: params.claimId, claimTab: "overview" },
    });
  },
});
